/*
 * DAP Leasing feed - POC katalog (vypis + detail) mimo Shopify produkty.
 * Data se tahaji z verejneho read-only endpointu feedu (bez klice, CORS allowlist).
 * Filtrovani, razeni i strankovani bezi cele v prohlizeci nad jednim stazenim.
 */
(function () {
  const CFG = Object.assign(
    {
      endpoint: '',
      pageSize: 12,
      vinParam: 'vin',
      ctaText: 'Nezávazně rezervovat',
      badgeText: 'skladem',
      // délka pronájmu je pro všechna auta stejná, nechodí z feedu
      durationText: 'Smlouva na 6 měsíců',
      // limit nájezdu je smluvní, taky stejný pro všechna auta
      mileageText: 'Nájezd 10 000 km za celou dobu pronájmu',
      // varianta pro auta s opt-inem navýšení nájezdu - část v [] je proklik na příplatek
      mileageUpsellText: 'Nájezd 10 000 nebo [15 000 km] za celou dobu pronájmu',
      cardNoteText: '10 000 km za 6 měsíců',
      buyHeading: 'Toto auto si můžete i koupit',
      buyText:
        'Nemusí zůstat jen u pronájmu, toto auto je možné si i přímo koupit. Zanechejte nám na sebe kontakt a domluvíme prohlídku a testovací jízdu.',
      buyCtaText: 'Nezávazně rezervovat',
      currency: 'CZK',
      leadWebhook: '',
      leadCategory: 'Prodej - Birne OV',
      leadSource: 'birne.com',
      submitText: 'Odeslat poptávku',
      // okno, kdy má telefon ve sticky liště smysl (pondělí až pátek, Europe/Prague)
      phoneFromHour: 9,
      phoneToHour: 17
    },
    window.DAPCarsConfig || {}
  );

  const VAT = 1.21;

  /* ---------- pomocné ---------- */

  // Sdílený stav DPH přepínače z ie-global.liquid: true == zobrazit ceny BEZ DPH
  const vatOff = () => {
    const urlState = new URLSearchParams(location.search).get('ico');
    if (urlState === 'true') return true;
    if (urlState === 'false') return false;

    try {
      const storedState = sessionStorage.getItem('VATState');
      if (storedState !== null) return storedState === 'true';
    } catch (e) {}

    return true;
  };

  // Měsíční splátka a příplatky chodí z feedu BEZ DPH a web je tak
  // ve výchozím stavu také zobrazuje. Neplatí pro koncovou cenu vozu - viz czkRaw níž.
  const czk = (value) =>
    new Intl.NumberFormat('cs-CZ', {
      style: 'currency',
      currency: 'CZK',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(vatOff() ? value : value * VAT);

  // Částky, které se DPH přepínačem nemění - zobrazují se přesně tak, jak přijdou z feedu.
  // Koncová cena vozu (priceCzk) chodí už s DPH, proto se nesmí přepočítávat.
  const czkRaw = (value) =>
    new Intl.NumberFormat('cs-CZ', {
      style: 'currency',
      currency: 'CZK',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);

  const num = (value) => new Intl.NumberFormat('cs-CZ').format(value);

  const ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  const esc = (value) => String(value == null ? '' : value).replace(/[&<>"']/g, (ch) => ESCAPES[ch]);

  // Do src/href pouštíme jen http(s) a interní cesty - data z feedu bereme jako nedůvěryhodná.
  const safeUrl = (value) => {
    const url = String(value == null ? '' : value).trim();
    return /^https?:\/\//i.test(url) ? url : '';
  };

  // Fotky chodí z feedu jako originály přes 3000 px (~650 kB na kus). Shopify CDN je umí
  // zmenšit přes ?width=, tak si o každé místo v layoutu řekneme jeho reálnou velikost.
  // Bez toho prohlížeč zmenšuje 11x a fotka na kartě vypadá přeostřeně (aliasing).
  const CDN_PREFIX = 'https://cdn.shopify.com/';
  const isCdn = (url) => String(url).slice(0, CDN_PREFIX.length).toLowerCase() === CDN_PREFIX;
  const imgUrl = (url, width) =>
    isCdn(url) ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width : url;

  // Varianty pro retinu - prohlížeč si vybere podle DPR a šířky, kterou mu řekne sizes.
  const imgSrcset = (url, widths) =>
    isCdn(url) ? widths.map((w) => imgUrl(url, w) + ' ' + w + 'w').join(', ') : '';

  const imgSized = (url, width, widths, sizes) => {
    const set = imgSrcset(url, widths);
    return (
      'src="' + esc(imgUrl(url, width)) + '"' +
      (set ? ' srcset="' + esc(set) + '" sizes="' + esc(sizes) + '"' : '')
    );
  };

  // Od 1300 px se sekce pouští až na 2100 px obsahu a mřížka si sloupce
  // dopočítává přes auto-fill minmax(330px, 1fr) - karta se drží v pásmu
  // 330-450 px. Mezi 1000 a 1300 px platí původní kontejner 1000 px s pevným
  // počtem sloupců, pod 1000 px se mřížka láme na 2 sloupce a pod 640 px na
  // jeden. Viz .dap-cars a .dap-grid v dap-cars.liquid.
  const cardSizes = () => {
    const cols = Number(CFG.columnsDesktop) || 3;
    return (
      '(min-width: 1300px) 450px, (min-width: 1000px) ' +
      Math.round((1000 - 24 * (cols - 1)) / cols) +
      'px, (min-width: 640px) 50vw, 100vw'
    );
  };

  const vatLabel = () => (vatOff() ? 'měsíčně bez DPH' : 'měsíčně s DPH');
  const priceNote = () =>
    [vatLabel(), CFG.durationText, CFG.mileageText].filter(Boolean).join(' · ');

  // Opt-in navýšení nájezdu poznáme podle názvu příplatku, cena se liší auto od auta.
  const MILEAGE_ADDON = /nájezd/i;
  const MILEAGE_ADDON_ID = 'dap-addon-mileage';

  // Na detailu stojí podmínky nájmu ve vlastním bloku, ne v řadě za cenou. Vrací hotové HTML.
  // S opt-inem navýšení nájezdu se ukáže delší varianta, kde část v [] vede dolů na příplatek.
  const termList = (upsell) => {
    const mileage =
      upsell && CFG.mileageUpsellText
        ? esc(CFG.mileageUpsellText).replace(
            /\[([^\]]+)\]/,
            '<a href="#' + MILEAGE_ADDON_ID + '" class="dap-terms__link" data-dap-scroll>$1</a>'
          )
        : esc(CFG.mileageText);
    return [esc(CFG.durationText), mileage].filter(Boolean);
  };

  // Na kartě ve výpisu je málo místa - krátká varianta poznámky na jeden řádek.
  const cardNote = () => CFG.cardNoteText || priceNote();

  const carTitle = (car) => (car.brand && car.model ? car.brand + ' ' + car.model : car.title || car.vin);

  // Cena, za kterou se vůz prodává. salePriceCzk chodí z feedu jen u zlevněných aut
  // a priceCzk je pak původní cena před slevou; bez slevy dorazí samotné priceCzk.
  // Obojí chodí už s DPH, proto se všude formátuje přes czkRaw.
  const buyPrice = (car) => Number(car.salePriceCzk) || Number(car.priceCzk) || 0;

  // Volitelné příplatky chodí z feedu jako objekty {label, monthlyPriceCzk}.
  // Starší podoba feedu posílala prosté stringy - obojí srovnáme na stejný tvar.
  const addonList = (car) =>
    (car.options || [])
      .map((o) =>
        typeof o === 'string'
          ? { label: o, price: null }
          : { label: o && o.label, price: o && o.monthlyPriceCzk != null ? o.monthlyPriceCzk : null }
      )
      .filter((a) => a.label);

  /* ---------- ikony (převzato z fig_product-card.liquid) ---------- */

  const ICONS = {
    engine:
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 8.99996V11.6666L9.33333 13.3333H2.66667C2.33333 13.3333 2 13 2 12.6666V5.33329C2 4.99996 2.33333 4.66663 2.66667 4.66663H6.33333M12 8.99996V6.33329L9.33333 4.66663H6.33333M12 8.99996H14M14 8.99996V7.66663M14 8.99996V10.3333M6.33333 4.66663V2.66663M6.33333 2.66663H5M6.33333 2.66663H7.66667" stroke="#004033" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.66669 7.33337L5.66669 9.00004H7.66669L6.66669 10.6667" stroke="#004033" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    fuel:
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 5.04139C2 4.09836 2.76439 3.33347 3.70879 3.33347C4.22959 3.33347 4.6664 3.33347 4.6664 3.33347V2H8V3.33347H9.3344C11.9108 3.33347 14 5.42219 14 7.99847C14 9.52607 14 11.1283 14 12.2933C14 12.7456 13.82 13.1809 13.4996 13.5009C13.1792 13.8209 12.7448 14.0012 12.2912 14.0012C10.01 14.0012 5.98999 14.0012 3.70879 14.0012C3.25519 14.0012 2.82081 13.8209 2.50041 13.5009C2.18001 13.1809 2 12.7456 2 12.2933C2 10.3027 2 7.032 2 5.04139Z" stroke="#004033" stroke-width="1.5" stroke-miterlimit="1.5" stroke-linecap="round" stroke-linejoin="round"/><path fill-rule="evenodd" clip-rule="evenodd" d="M7.9994 6C7.9994 6 9.9994 7.9956 9.9996 9.25767C9.9998 10.3615 9.10347 11.2577 7.9998 11.2577C6.89613 11.2577 6.008 10.3615 6 9.25767C6.00653 7.99493 7.9994 6 7.9994 6Z" stroke="#004033" stroke-width="1.5" stroke-miterlimit="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    transmission:
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.66669 5.33337V11.3334" stroke="#004033" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.6667 11.3334V11.3406" stroke="#004033" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.33331 8.66671H9.99996C10.3683 8.66671 10.6666 8.33379 10.6666 7.92281V5.33337" stroke="#004033" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.66669 5.33337V11.3334" stroke="#004033" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.01099 2.83337H10.3218C12.178 2.83337 13.3333 4.14375 13.3333 5.99813V11.002C13.3333 12.8563 12.178 14.1667 10.3211 14.1667H5.01099C3.15477 14.1667 2 12.8563 2 11.002V5.99813C2 4.14375 3.16029 2.83337 5.01099 2.83337Z" stroke="#004033" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    chassis:
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.33331 11.3333C3.33331 11.3333 3.33331 10 4.66665 10C5.99998 10 5.99998 11.3333 5.99998 11.3333V12.6667C5.99998 12.6667 5.99998 14 4.66665 14C3.33331 14 3.33331 12.6667 3.33331 12.6667V11.3333Z" stroke="#004033" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.33331 3.33333C3.33331 3.33333 3.33331 2 4.66665 2C5.99998 2 5.99998 3.33333 5.99998 3.33333V4.66667C5.99998 4.66667 5.99998 6 4.66665 6C3.33331 6 3.33331 4.66667 3.33331 4.66667V3.33333Z" stroke="#004033" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M10 11.3333C10 11.3333 10 10 11.3333 10C12.6667 10 12.6667 11.3333 12.6667 11.3333V12.6667C12.6667 12.6667 12.6667 14 11.3333 14C10 14 10 12.6667 10 12.6667V11.3333Z" stroke="#004033" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M10 3.33333C10 3.33333 10 2 11.3333 2C12.6667 2 12.6667 3.33333 12.6667 3.33333V4.66667C12.6667 4.66667 12.6667 6 11.3333 6C10 6 10 4.66667 10 4.66667V3.33333Z" stroke="#004033" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 4V12M8 4H10M8 4H6M8 12H10M8 12H6" stroke="#004033" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    photo:
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.3335 12.6667V6C1.3335 5.26362 1.93045 4.66667 2.66683 4.66667H3.00016C3.41984 4.66667 3.81502 4.46907 4.06683 4.13333L5.54683 2.16C5.62237 2.05928 5.74093 2 5.86683 2H10.1335C10.2594 2 10.378 2.05928 10.4535 2.16L11.9335 4.13333C12.1853 4.46907 12.5805 4.66667 13.0002 4.66667H13.3335C14.0699 4.66667 14.6668 5.26362 14.6668 6V12.6667C14.6668 13.4031 14.0699 14 13.3335 14H2.66683C1.93045 14 1.3335 13.4031 1.3335 12.6667Z" stroke="#004033" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.00016 11.6667C9.4729 11.6667 10.6668 10.4727 10.6668 9.00001C10.6668 7.52728 9.4729 6.33334 8.00016 6.33334C6.5274 6.33334 5.3335 7.52728 5.3335 9.00001C5.3335 10.4727 6.5274 11.6667 8.00016 11.6667Z" stroke="#004033" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    // Logo Cebia - stejný štítek na kartě ve výpisu i na detailu vozu. Maska z originálního
    // SVG je vypuštěná záměrně: přesně kopíruje bbox šipky, takže nic neořízne, a její id
    // by se ve výpisu opakovalo u každé karty.
    cebia:
      '<svg class="dap-cebia__logo" width="59" height="15" viewBox="0 0 59 15" fill="none" role="img" aria-label="Prověřeno Cebia" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M58.655 7.84033L54.3925 3.57748C54.3563 3.54131 54.3134 3.51261 54.2661 3.49303C54.2189 3.47346 54.1682 3.46338 54.1171 3.46338C54.0659 3.46338 54.0153 3.47346 53.968 3.49303C53.9207 3.51261 53.8778 3.54131 53.8416 3.57748L53.1071 4.31202C53.0709 4.34819 53.0422 4.39112 53.0227 4.43838C53.0031 4.48564 52.993 4.53629 52.993 4.58744C52.993 4.6386 53.0031 4.68925 53.0227 4.7365C53.0422 4.78376 53.0709 4.8267 53.1071 4.86287L55.4511 7.20656H48.6176C48.5143 7.20656 48.4152 7.24759 48.3421 7.32062C48.2691 7.39366 48.228 7.49272 48.228 7.59602V8.63448C48.228 8.73779 48.2691 8.83687 48.3421 8.90993C48.4152 8.98298 48.5143 9.02402 48.6176 9.02402H55.4511L53.1071 11.3679C53.0709 11.4041 53.0422 11.447 53.0227 11.4943C53.0031 11.5416 52.993 11.5922 52.993 11.6434C52.993 11.6945 53.0031 11.7452 53.0227 11.7924C53.0422 11.8397 53.0709 11.8826 53.1071 11.9188L53.8416 12.6533C53.8778 12.6895 53.9207 12.7182 53.968 12.7378C54.0153 12.7574 54.0659 12.7674 54.1171 12.7674C54.1682 12.7674 54.2189 12.7574 54.2661 12.7378C54.3134 12.7182 54.3563 12.6895 54.3925 12.6533L58.655 8.39087C58.6911 8.3547 58.7198 8.31176 58.7394 8.2645C58.759 8.21725 58.7691 8.1666 58.7691 8.11544C58.7691 8.06429 58.759 8.01364 58.7394 7.96638C58.7198 7.91912 58.6911 7.87619 58.655 7.84002" fill="#77E92B"/>' +
      '<path d="M25.1559 4.49797C24.0643 4.49634 23.0049 4.86821 22.1538 5.55182V1.41243L20.3525 0.895508V14.105L22.1538 13.5046V13.0507C22.753 13.5305 23.4584 13.8597 24.2109 14.0108C24.9635 14.1619 25.7413 14.1304 26.4791 13.919C27.217 13.7076 27.8935 13.3225 28.4519 12.7959C29.0103 12.2692 29.4344 11.6165 29.6886 10.8922C29.9428 10.168 30.0197 9.39336 29.913 8.63327C29.8062 7.87317 29.5189 7.14972 29.075 6.52353C28.6311 5.89734 28.0436 5.38664 27.3617 5.03422C26.6799 4.6818 25.9235 4.49791 25.1559 4.49797ZM25.1559 12.3036C24.5621 12.3036 23.9817 12.1275 23.488 11.7977C22.9943 11.4678 22.6095 10.9989 22.3822 10.4503C22.155 9.90177 22.0955 9.29813 22.2114 8.71576C22.3272 8.13339 22.6131 7.59845 23.033 7.17859C23.4529 6.75873 23.9878 6.4728 24.5702 6.35696C25.1525 6.24112 25.7562 6.30058 26.3048 6.52782C26.8533 6.75505 27.3222 7.13986 27.6521 7.63357C27.982 8.12729 28.158 8.70773 28.158 9.30151C28.158 10.0977 27.8417 10.8613 27.2787 11.4243C26.7157 11.9873 25.9521 12.3036 25.1559 12.3036Z" fill="#01215A"/>' +
      '<path d="M32.9617 13.5046L31.1604 14.1046V4.49951L32.9617 5.09859V13.5046Z" fill="#01215A"/>' +
      '<path d="M41.9678 4.4982V5.55205C41.2614 4.98637 40.4095 4.63176 39.5103 4.52907C38.6112 4.42638 37.7013 4.5798 36.8855 4.97165C36.0698 5.36349 35.3813 5.97782 34.8994 6.74387C34.4175 7.50991 34.1619 8.39651 34.1619 9.30151C34.1619 10.2065 34.4175 11.0931 34.8994 11.8592C35.3813 12.6252 36.0698 13.2395 36.8855 13.6314C37.7013 14.0232 38.6112 14.1766 39.5103 14.074C40.4095 13.9713 41.2614 13.6167 41.9678 13.051V14.1048L43.7691 13.5044V5.09874L41.9678 4.4982ZM38.9657 12.3038C38.3719 12.3038 37.7915 12.1278 37.2978 11.7979C36.8041 11.468 36.4193 10.9991 36.192 10.4506C35.9648 9.902 35.9053 9.29836 36.0212 8.71599C36.137 8.13362 36.4229 7.59868 36.8428 7.17882C37.2627 6.75896 37.7976 6.47303 38.38 6.35719C38.9623 6.24136 39.566 6.30082 40.1145 6.52805C40.6631 6.75529 41.132 7.14009 41.4619 7.63381C41.7917 8.12752 41.9678 8.70796 41.9678 9.30174C41.9678 9.69597 41.8902 10.0863 41.7393 10.4506C41.5885 10.8148 41.3674 11.1458 41.0886 11.4245C40.8098 11.7033 40.4789 11.9244 40.1147 12.0753C39.7505 12.2262 39.3601 12.3038 38.9659 12.3038" fill="#01215A"/>' +
      '<path d="M32.9617 3.59798L31.1604 2.99798V1.19629L32.9617 1.79629V3.59798Z" fill="#77E92B"/>' +
      '<path d="M5.34166 12.3038C4.861 12.3038 4.38737 12.1884 3.96058 11.9673C3.5338 11.7462 3.16634 11.4258 2.88912 11.0332C2.61189 10.6405 2.433 10.187 2.36748 9.71087C2.30197 9.2347 2.35174 8.74975 2.51262 8.29681C2.6735 7.84388 2.94079 7.43619 3.292 7.10804C3.64321 6.77988 4.06808 6.54085 4.53088 6.41105C4.99368 6.28125 5.48089 6.26447 5.95153 6.36212C6.42216 6.45976 6.86247 6.66899 7.23543 6.9722L9.10828 6.32074C8.48927 5.53851 7.64208 4.9684 6.68433 4.68955C5.72657 4.4107 4.70576 4.43694 3.76359 4.76463C2.82143 5.09232 2.00465 5.7052 1.42665 6.5182C0.848643 7.3312 0.538086 8.30398 0.538086 9.30151C0.538086 10.299 0.848643 11.2718 1.42665 12.0848C2.00465 12.8978 2.82143 13.5107 3.76359 13.8384C4.70576 14.1661 5.72657 14.1923 6.68433 13.9135C7.64208 13.6346 8.48927 13.0645 9.10828 12.2823L7.23543 11.6308C6.7007 12.0668 6.03163 12.3045 5.34166 12.3035" fill="#01215A"/>' +
      '<path d="M5.3253 12.3206C4.84139 12.3206 4.36457 12.2043 3.93502 11.9815C3.50547 11.7587 3.13578 11.4358 2.85711 11.0402C2.57845 10.6446 2.39897 10.1878 2.33381 9.70829C2.26865 9.22879 2.31971 8.74065 2.48269 8.28501C2.64568 7.82937 2.91581 7.41959 3.27031 7.09021C3.62482 6.76082 4.05331 6.52149 4.51968 6.39237C4.98604 6.26326 5.47662 6.24815 5.95005 6.34831C6.42348 6.44848 6.86589 6.66099 7.23999 6.96793L9.12376 6.33962C8.50742 5.5527 7.66094 4.97765 6.70228 4.69462C5.74363 4.4116 4.72055 4.43469 3.77564 4.76068C2.83073 5.08668 2.01106 5.69933 1.43085 6.51327C0.85065 7.3272 0.538818 8.30187 0.538818 9.30143C0.538818 10.301 0.85065 11.2757 1.43085 12.0896C2.01106 12.9035 2.83073 13.5162 3.77564 13.8422C4.72055 14.1682 5.74363 14.1913 6.70228 13.9082C7.66094 13.6252 8.50742 13.0502 9.12376 12.2632L7.23999 11.6357C6.70068 12.0794 6.02368 12.3215 5.3253 12.3203" fill="#01215A"/>' +
      '<path d="M19.0668 10.2022C19.2872 9.04764 19.0767 7.85233 18.4752 6.84252C17.8736 5.83272 16.9227 5.07848 15.8025 4.72258C14.6823 4.36669 13.4704 4.43383 12.3963 4.91129C11.3223 5.38876 10.4605 6.24342 9.97421 7.3135C9.48788 8.38358 9.41072 9.59482 9.75735 10.718C10.104 11.8411 10.8503 12.7982 11.8551 13.4081C12.8599 14.018 14.0535 14.2383 15.2098 14.0274C16.3661 13.8165 17.405 13.1891 18.1298 12.2637L16.2392 11.6336C15.8588 11.942 15.4088 12.1527 14.9284 12.2474C14.4479 12.3421 13.9516 12.3178 13.4827 12.1767C13.0138 12.0356 12.5864 11.782 12.238 11.438C11.8895 11.0939 11.6305 10.6699 11.4835 10.2028L19.0668 10.2022ZM11.4833 8.40088C11.6752 7.79145 12.0564 7.25908 12.5715 6.88116C13.0867 6.50324 13.709 6.29947 14.3479 6.29947C14.9868 6.29947 15.6091 6.50324 16.1242 6.88116C16.6394 7.25908 17.0206 7.79145 17.2125 8.40088H11.4833Z" fill="#01215A"/>' +
      '</svg>',
    // ikony k sekci "Co je v ceně" - barvu řídí CSS přes currentColor
    included:
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.31814 11.6819 1.33337 8 1.33337C4.31814 1.33337 1.33337 4.31814 1.33337 8C1.33337 11.6819 4.31814 14.6667 8 14.6667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.33337 8.33337L7.00004 10L10.6667 6.33337" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    excluded:
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.31814 11.6819 1.33337 8 1.33337C4.31814 1.33337 1.33337 4.31814 1.33337 8C1.33337 11.6819 4.31814 14.6667 8 14.6667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M6 6L10 10M10 6L6 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    info:
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.31814 11.6819 1.33337 8 1.33337C4.31814 1.33337 1.33337 4.31814 1.33337 8C1.33337 11.6819 4.31814 14.6667 8 14.6667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 10.6667V7.33337" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 5.33337H8.00667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    // ie-icon-plus - base.css ho otáčí přes .facets .disclosure-has-popup[open] > summary > div > svg
    caret:
      '<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.5 9L12.5 15L18.5 9" stroke="#004033" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    checkmark:
      '<svg class="icon icon-checkmark tw-hidden" width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 3.5L2.83333 4.75L4.16667 6L9.5 1" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  /* ---------- stav ---------- */

  // Filtr podle pobočky je skrytý, ukáže se jen s ?lokalita v URL. Vyhodnocuje se
  // jednou při startu - kdyby se to řešilo při každém překreslení, mohl by po
  // návratu z detailu zůstat aktivní filtr, který nemá viditelné ovládání.
  function urlFlag(name) {
    const value = new URLSearchParams(location.search).get(name);
    return value !== null && ['0', 'false', 'no'].indexOf(value.toLowerCase()) === -1;
  }

  // Facet obvykle čte hodnotu rovnou z pole vozu. Když se pole nedá nabídnout tak,
  // jak chodí z feedu (boolean towbar), přeloží ho vlastní `value`.
  const facetValue = (f, car) => (f.value ? f.value(car) : car[f.key]);

  const FACETS = [
    { key: 'brand', label: 'Značka' },
    // Model má smysl nabízet až nad vybranou značkou - přes celý katalog jich je přes 60.
    { key: 'model', label: 'Model', requires: 'brand', lockedHint: 'Nejdřív vyberte značku.' },
    { key: 'fuel', label: 'Palivo' },
    { key: 'bodyType', label: 'Karoserie' },
    { key: 'transmission', label: 'Převodovka' },
    { key: 'towbar', label: 'Tažné zařízení', value: (c) => (c.towbar == null ? '' : c.towbar ? 'Ano' : 'Ne') }
  ];

  if (urlFlag('lokalita')) FACETS.push({ key: 'branch', label: 'Pobočka' });

  const SORTS = [
    {
      value: 'monthly-asc',
      label: 'Splátka: od nejnižší',
      fn: (a, b) => (a.monthlyPaymentCzk || Infinity) - (b.monthlyPaymentCzk || Infinity)
    },
    {
      value: 'monthly-desc',
      label: 'Splátka: od nejvyšší',
      fn: (a, b) => (b.monthlyPaymentCzk || 0) - (a.monthlyPaymentCzk || 0)
    },
    {
      value: 'price-asc',
      label: 'Cena vozu: od nejnižší',
      fn: (a, b) => (buyPrice(a) || Infinity) - (buyPrice(b) || Infinity)
    },
    { value: 'year-desc', label: 'Rok: od nejnovějšího', fn: (a, b) => (b.year || 0) - (a.year || 0) },
    {
      value: 'mileage-asc',
      label: 'Nájezd: od nejnižšího',
      fn: (a, b) => (a.mileage || Infinity) - (b.mileage || Infinity)
    }
  ];

  const state = {
    cars: [],
    filters: {},
    sort: SORTS[0].value,
    shown: CFG.pageSize
  };

  FACETS.forEach((f) => {
    state.filters[f.key] = new Set();
  });

  let root, listView, detailView, facetsEl, gridEl, countEl, moreEl, sortEl, toolbarEl;

  // Příplatky vykreslené na aktuálním detailu - index checkboxu odkazuje sem.
  let detailAddons = [];

  /* ---------- načtení dat ---------- */

  // Strop API - 201 vrací 400. Katalog má dnes ~140 aut, takže se vejde do
  // jednoho requestu; cursor smyčka níž zůstává pro případ, že sklad povyroste.
  const FEED_LIMIT = '200';

  async function fetchAll() {
    const out = [];
    let cursor = '';
    // První stránku obvykle rozjede inline <script> v sekci (viz DAPCarsPreload
    // v dap-cars.liquid) ještě než se stáhne tenhle soubor - tady si ji jen
    // vyzvedneme. Když preload chybí nebo selhal, stáhneme ji normálně.
    let preload = window.DAPCarsPreload || null;

    for (let guard = 0; guard < 50; guard++) {
      let json = null;

      if (!cursor && preload) {
        const pending = preload;
        preload = null;
        try {
          json = await pending;
        } catch (err) {
          json = null;
        }
      }

      if (!json) {
        const url = new URL(CFG.endpoint, location.origin);
        url.searchParams.set('limit', FEED_LIMIT);
        if (cursor) url.searchParams.set('cursor', cursor);
        const res = await fetch(url.toString(), { headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error('feed odpověděl ' + res.status);
        json = await res.json();
      }

      out.push.apply(out, json.data || []);
      cursor = (json.meta && json.meta.nextCursor) || '';
      if (!cursor) break;
    }
    return out;
  }

  async function fetchCar(vin) {
    const path = CFG.endpoint.replace(/\/$/, '') + '/' + encodeURIComponent(vin);
    const res = await fetch(new URL(path, location.origin).toString(), {
      headers: { Accept: 'application/json' }
    });
    if (!res.ok) throw new Error('vůz se nepodařilo načíst (' + res.status + ')');
    const json = await res.json();
    return json.data;
  }

  /* ---------- filtrování ---------- */

  function matches(car, skipKey) {
    return FACETS.every((f) => {
      if (f.key === skipKey) return true;
      const sel = state.filters[f.key];
      return sel.size === 0 || sel.has(facetValue(f, car));
    });
  }

  function filtered() {
    const sort = SORTS.find((s) => s.value === state.sort) || SORTS[0];
    return state.cars.filter((car) => matches(car)).sort(sort.fn);
  }

  // Závislý facet (Model) je bez nadřazeného výběru zamčený. Kdyby v něm po odškrtnutí
  // značky zůstala vybraná hodnota, filtrovala by dál - jen bez ovládání, kterým by
  // se dala zrušit. Volá se po každé změně filtrů, ne až při vykreslení.
  function pruneDependent() {
    FACETS.forEach((f) => {
      if (!f.requires) return;
      const sel = state.filters[f.key];
      if (!sel.size) return;
      const parent = state.filters[f.requires];
      if (!parent.size) {
        sel.clear();
        return;
      }
      const parentFacet = FACETS.find((p) => p.key === f.requires);
      [...sel].forEach((value) => {
        const offered = state.cars.some(
          (car) => facetValue(f, car) === value && parent.has(facetValue(parentFacet, car))
        );
        if (!offered) sel.delete(value);
      });
    });
  }

  /* ---------- výpis ---------- */

  function cardHtml(car) {
    const img = safeUrl(car.images && car.images[0]);
    const photos = (car.images || []).length;
    const params = [
      [ICONS.engine, car.powerKw ? car.powerKw + ' kW' : ''],
      [ICONS.fuel, car.fuel],
      [ICONS.transmission, car.transmission],
      [ICONS.chassis, car.bodyType]
    ].filter((p) => p[1]);

    return (
      '<a href="' +
      esc(urlWith(car.vin)) +
      '" data-dap-link class="tw-w-full tw-h-full">' +
      '<div class="js-product-card tw-flex tw-flex-col tw-rounded-[3.2rem] tw-p-[2.4rem] tw-pt-[8px] tw-border tw-border-[#C4E9DC] tw-w-full tw-bg-white tw-h-full focus:tw-shadow-[0px_0px_12px_4px_rgba(135,_67,_255,_0.20)] hover:tw-shadow-[0px_0px_12px_4px_rgba(135,_67,_255,_0.20)] tw-text-primaryDarker tw-relative">' +
      '<div class="dap-card__media">' +
      (img
        ? '<img loading="lazy" decoding="async" class="dap-card__img" ' +
          imgSized(img, 600, [400, 600, 800, 1200], cardSizes()) +
          ' alt="' +
          esc(carTitle(car)) +
          '">'
        : '') +
      // počet fotek sedí přes fotku vpravo dole - v řádku štítků pod ní teď stojí Cebia
      (photos
        ? '<div class="dap-card__photos">' + ICONS.photo + '<span>' + photos + '</span></div>'
        : '') +
      '</div>' +
      // tw-flex-1, ne tw-h-full - h-full je 100 % VÝŠKY CELÉ KARTY (i s fotkou), takže si
      // blok řekl o víc místa, než kolik ho pod fotkou zbývá. Flexbox ten přebytek strhl
      // z .dap-card__media (ta má overflow:hidden, takže se smrskne až na nulu) a uvnitř
      // textu ho tw-mt-auto u ceny vysypalo jako prázdné místo nad cenou.
      '<div class="tw-flex tw-flex-1 tw-pt-0 tw-flex-col tw-gap-[2.4rem] tw-items-start sm:tw-gap-[3.4rem]">' +
      '<div class="tw-flex tw-flex-col tw-items-start tw-gap-[1.2rem]">' +
      '<div class="tw-flex tw-items-center tw-gap-[4px]">' +
      (CFG.badgeText
        ? '<span class="tw-px-[8px] tw-py-[6px] tw-rounded-[1.6rem] tw-lowercase tw-bg-green-500 tw-text-primaryDarker tw-font-semibold tw-leading-[100%] tw-tracking-[0.05em] tw-text-[1.2rem]">' +
          esc(CFG.badgeText) +
          '</span>'
        : '') +
      '<span class="dap-cebia">' + ICONS.cebia + '</span>' +
      '</div>' +
      '<p class="tw-text-[2rem] md:tw-text-[2.4rem] tw-leading-[1.2] tw-tracking-[0.01em] tw-font-medium tw-mt-[2px]">' +
      esc(carTitle(car)) +
      '</p>' +
      '</div>' +
      (params.length
        ? '<div class="tw-grid tw-grid-cols-2 sm:tw-grid-rows-2 tw-gap-[1.2rem]">' +
          params
            .map(
              (p) =>
                '<div class="tw-flex tw-gap-[4px] tw-text-[12px] tw-font-[500]">' + p[0] + esc(p[1]) + '</div>'
            )
            .join('') +
          '</div>'
        : '') +
      '<div class="tw-flex tw-flex-col tw-gap-[4px] tw-mt-auto">' +
      '<div class="cell-price tw-flex tw-items-center tw-gap-[4px]">' +
      '<span class="tw-leading-[20px] tw-text-[12px]">za</span>' +
      '<span class="tw-font-[700] tw-text-[1.8rem] md:tw-text-[2rem] tw-leading-[3rem]">' +
      (car.monthlyPaymentCzk ? czk(car.monthlyPaymentCzk) : 'cena na dotaz') +
      '</span>' +
      '</div>' +
      // DPH štítek má vlastní řádek - v úzké kartě by se za cenu nevešel
      (car.monthlyPaymentCzk
        ? '<div class="tw-text-[12px] tw-leading-[20px]">' + esc(vatLabel()) + '</div>'
        : '') +
      (car.monthlyPaymentCzk
        ? '<div class="tw-text-[12px] tw-text-green-700 tw-font-medium tw-tracking-[0.02em] tw-leading-[1.2]">' +
          esc(cardNote()) +
          '</div>'
        : '') +
      '</div>' +
      '</div>' +
      '</div></a>'
    );
  }

  // Zamčený facet drží místo v řádku, dokud není vybraný nadřazený filtr - jinak by
  // se řádek filtrů po výběru značky přeskládal. Rozbalit jde, uvnitř je důvod.
  function lockedFacetHtml(f, open) {
    return (
      '<details class="disclosure-has-popup facets__disclosure js-filter dap-facet--locked tw-min-w-[111.4px]" data-facet="' +
      esc(f.key) + '"' + (open.has(f.key) ? ' open' : '') + '>' +
      '<summary class="facets__summary caption-large focus-offset tw-border tw-rounded-[16px] tw-p-[16px]"' +
      ' aria-label="' + esc(f.label) + ' - ' + esc(f.lockedHint) + '">' +
      '<div class="tw-w-full">' +
      '<div class="tw-text-[14px] tw-font-medium tw-flex tw-gap-[8px] tw-items-center [&>div]:!tw-w-[16px]">' +
      '<span>' + esc(f.label) + '</span>' +
      '</div>' +
      ICONS.caret +
      '</div>' +
      '</summary>' +
      '<div class="parent-display facets__display !tw-left-0 tw-w-[24rem]">' +
      '<p class="dap-facet__hint">' + esc(f.lockedHint) + '</p>' +
      '</div></details>'
    );
  }

  // Rozbalovací facety ve stejné struktuře jako snippets/facets.liquid, aby se na ně
  // chytly styly z component-facets.css (.facets__display se pozicuje absolutně vůči
  // .disclosure-has-popup, šipka se otáčí přes .facets .disclosure-has-popup[open]).
  function renderFacets() {
    // <details> se při překreslení zavře, takže si otevřené facety pamatujeme
    const open = new Set(
      [...facetsEl.querySelectorAll('details[open][data-facet]')].map((d) => d.dataset.facet)
    );

    facetsEl.innerHTML = FACETS.map((f) => {
      if (f.requires && !state.filters[f.requires].size) return lockedFacetHtml(f, open);

      // počty se počítají nad ostatními aktivními filtry, aby seděly jako u Shopify facet
      const values = {};
      state.cars.forEach((car) => {
        const v = facetValue(f, car);
        if (!v) return;
        if (!(v in values)) values[v] = 0;
        if (matches(car, f.key)) values[v] += 1;
      });

      const keys = Object.keys(values).sort((a, b) => a.localeCompare(b, 'cs', { numeric: true }));
      if (!keys.length) return '';

      const sel = state.filters[f.key];

      const items = keys
        .map((v) => {
          const checked = sel.has(v);
          const unavailable = values[v] === 0 && !checked;
          return (
            '<li class="list-menu__item facets__item' + (unavailable ? ' tw-hidden' : '') + '">' +
            '<label class="facet-checkbox' + (unavailable ? ' facet-checkbox--disabled' : '') + ' tw-p-0">' +
            '<input type="checkbox" data-facet="' + esc(f.key) + '" value="' + esc(v) + '"' +
            (checked ? ' checked' : '') + (unavailable ? ' disabled' : '') + '>' +
            ICONS.checkmark +
            '<span aria-hidden="true" class="tw-px-[16px] tw-py-[12px] tw-border tw-border-primaryDarker tw-rounded-[1.6rem] filter-text-label tw-flex tw-gap-[5px] tw-items-center tw-text-[14px] tw-font-medium tw-whitespace-nowrap">' +
            '<span>' + esc(v) + '</span></span>' +
            '<span class="visually-hidden">' + esc(v) + ' (' + values[v] + ')</span>' +
            '</label></li>'
          );
        })
        .join('');

      return (
        '<details class="disclosure-has-popup facets__disclosure js-filter tw-min-w-[111.4px]" data-facet="' +
        esc(f.key) + '"' + (open.has(f.key) ? ' open' : '') + '>' +
        '<summary class="facets__summary caption-large focus-offset tw-border-primaryDarker tw-border tw-rounded-[16px] tw-p-[16px]"' +
        ' aria-label="' + esc(f.label) + '">' +
        '<div class="tw-w-full">' +
        '<div class="tw-text-[14px] tw-font-medium tw-text-primaryDarker tw-flex tw-gap-[8px] tw-items-center [&>div]:!tw-w-[16px]">' +
        '<span>' + esc(f.label) + '</span>' +
        '<span class="facets__selected' + (sel.size ? '' : ' hidden') + '">(' + sel.size + ')</span>' +
        '</div>' +
        ICONS.caret +
        '</div>' +
        '</summary>' +
        '<div class="parent-display facets__display !tw-left-0 tw-w-[24rem] tw-max-h-[40rem]">' +
        '<div class="facets__header">' +
        '<span class="facets__selected">' + (sel.size ? sel.size + ' vybráno' : 'Vyberte') + '</span>' +
        (sel.size
          ? '<button type="button" class="facets__reset link underlined-link" data-facet-reset="' +
            esc(f.key) + '">Zrušit</button>'
          : '') +
        '</div>' +
        '<fieldset class="facets-wrap parent-wrap">' +
        '<legend class="visually-hidden">' + esc(f.label) + '</legend>' +
        '<ul class="facets__list list-unstyled tw-flex tw-flex-wrap tw-gap-[16px]" role="list">' +
        items +
        '</ul></fieldset></div></details>'
      );
    }).join('');
  }

  function carsLabel(n) {
    if (n === 1) return 'vůz';
    if (n >= 2 && n <= 4) return 'vozy';
    return 'vozů';
  }

  function renderGrid() {
    const list = filtered();
    countEl.textContent = list.length + ' ' + carsLabel(list.length);

    if (!list.length) {
      gridEl.innerHTML = '<p class="dap-empty">Žádné auto neodpovídá zvolenému filtru.</p>';
      moreEl.hidden = true;
      return;
    }

    gridEl.innerHTML = list.slice(0, state.shown).map(cardHtml).join('');
    moreEl.hidden = list.length <= state.shown;
    moreEl.textContent = 'Načíst další (' + (list.length - state.shown) + ')';
  }

  function renderList() {
    renderFacets();
    renderGrid();
  }

  /* ---------- detail ---------- */

  const SPECS = [
    ['Značka', (c) => c.brand],
    ['Model', (c) => c.model],
    ['Rok výroby', (c) => c.year],
    ['První registrace', (c) => (c.firstRegistration ? new Date(c.firstRegistration).toLocaleDateString('cs-CZ') : '')],
    ['Palivo', (c) => c.fuel],
    ['Převodovka', (c) => c.transmission],
    ['Karoserie', (c) => c.bodyType],
    ['Výkon', (c) => (c.powerKw ? c.powerKw + ' kW' : '')],
    ['Objem motoru', (c) => (c.engineVolume ? num(c.engineVolume) + ' cm3' : '')],
    ['Nájezd', (c) => (c.mileage != null ? num(c.mileage) + ' km' : '')],
    ['Počet dveří', (c) => c.doors],
    ['Počet míst', (c) => c.seats],
    ['Barva', (c) => c.color],
    ['Stav', (c) => c.condition],
    ['Tažné zařízení', (c) => (c.towbar == null ? '' : c.towbar ? 'ano' : 'ne')],
    // Pobočka tu jako obyčejný řádek není - zobrazuje ji jen A/B/C test, viz locRowHtml().
    // Cena vozu z tabulky zmizela - stojí ve vlastním bloku "Auto si můžete i koupit",
    // kde je jasné, že jde o nabídku, ne o další technický údaj.
    ['VIN', (c) => c.vin]
  ];

  // Auto z operáku jde i koupit. Cena v tabulce parametrů se četla jako technický
  // údaj, proto stojí ve vlastním bloku pod parametry. Bez ceny z feedu se blok
  // nevykreslí - stejně jako když se v nastavení sekce vyprázdní nadpis.
  function buyBlockHtml(car) {
    const price = buyPrice(car);
    // Původní cena se ukáže přeškrtnutá jen u zlevněného vozu. Když by byla stejná
    // nebo nižší než prodejní, nemá co dodat a vynecháme ji.
    const before = car.salePriceCzk && Number(car.priceCzk) > price ? Number(car.priceCzk) : 0;
    if (!price || !CFG.buyHeading) return '';
    return (
      '<section class="dap-buy">' +
      '<h2 class="dap-buy__heading">' + esc(CFG.buyHeading) + '</h2>' +
      (CFG.buyText ? '<p class="dap-buy__text">' + esc(CFG.buyText) + '</p>' : '') +
      '<div class="dap-buy__row">' +
      '<p class="dap-buy__price">' +
      '<span class="dap-buy__head">' +
      '<span class="dap-buy__label">Cena vozu</span>' +
      (before ? '<s class="dap-buy__before">' + czkRaw(before) + '</s>' : '') +
      '</span>' +
      '<span class="dap-buy__amount">' + czkRaw(price) + '</span>' +
      '</p>' +
      '<button type="button" class="button button-dark-green dap-buy__cta" data-dap-buy>' +
      esc(CFG.buyCtaText) +
      '</button>' +
      '</div>' +
      '</section>'
    );
  }

  // Podmínky služby jsou pro všechna auta stejné, do feedu nepatří.
  const INCLUDED = [
    [
      'included',
      'Obsahuje předepsaný servis, povinné ručení (POV), havarijní pojištění (HAV), pojištění skel, poplatek za rádio a GPS ochranu auta.'
    ],
    ['info', 'Dálniční známku a dostupnost zimních pneumatik ověříte na místě s prodejcem.']
  ];

  /* ---------- A/B/C test lokality (VWO kampaň #28) ---------- */

  // Má detail ukazovat, kde auto stojí? Varianty přepíná VWO jediným zásahem -
  // atributem data-dap-loc na <html>:
  //   bez atributu = control, řádek "Umístění auta" se nezobrazí (dosavadní stav)
  //   a = lokalita vidět + ikona "i", vysvětlivka na hover i na klik
  //   b = lokalita rozmazaná, klik otevře vysvětlivku a teprve tlačítko v ní ji odkryje
  // Atribut na <html> přežije překreslení detailu i přechody výpis <-> detail;
  // zásah VWO přímo do markupu by každé route() smazalo. Markup všech variant je
  // proto tady, ne ve VWO editoru - když VWO nedojede, platí control.
  // Po skončení testu smazat i se styly .dap-loc v dap-cars.liquid a VWO.event('dapLead').

  // Převoz na jinou pobočku je zpoplatněný - do textu nepsat "zdarma".
  const LOC_TEXT = 'Víte, že každé auto z naší nabídky vám můžeme převézt na pobočku, kterou máte nejblíže?';

  // Pražské pobočky zákazník rozlišovat nepotřebuje. Mění se jen zobrazení -
  // lead i skrytý filtr ?lokalita dál pracují s hodnotou z feedu.
  const locLabel = (branch) => (/^Praha\s*[-–]\s*(Malešice|Horní Počernice)$/.test(branch) ? 'Praha' : branch);

  // Náhled varianty bez VWO: ?dap_loc=a nebo ?dap_loc=b
  const forcedLoc = new URLSearchParams(location.search).get('dap_loc');
  if (forcedLoc === 'a' || forcedLoc === 'b') document.documentElement.setAttribute('data-dap-loc', forcedLoc);

  // Vykresluje se vždy a o viditelnosti rozhoduje CSS podle data-dap-loc - VWO
  // může atribut nastavit i až po vykreslení detailu.
  function locRowHtml(car) {
    if (!car.branch) return '';
    const label = esc(locLabel(car.branch));
    return (
      '<div class="dap-specs__row dap-loc">' +
      '<dt>Umístění auta</dt>' +
      '<dd>' +
      '<span class="dap-loc__arm dap-loc__arm--a">' +
      '<span>' + label + '</span>' +
      '<button type="button" class="dap-loc__info" data-dap-loc-toggle aria-expanded="false"' +
      ' aria-controls="dap-loc-pop-a" aria-label="Převoz auta na jinou pobočku">' +
      ICONS.info +
      '</button>' +
      '<span class="dap-loc__pop" id="dap-loc-pop-a" role="tooltip">' + esc(LOC_TEXT) + '</span>' +
      '</span>' +
      '<span class="dap-loc__arm dap-loc__arm--b">' +
      '<button type="button" class="dap-loc__blur" data-dap-loc-toggle aria-expanded="false"' +
      ' aria-controls="dap-loc-pop-b" aria-label="Zobrazit umístění auta">' +
      '<span aria-hidden="true">' + label + '</span>' +
      '</button>' +
      '<span class="dap-loc__value" tabindex="-1">' + label + '</span>' +
      '<span class="dap-loc__pop" id="dap-loc-pop-b">' +
      '<span class="dap-loc__text">' + esc(LOC_TEXT) + '</span>' +
      '<button type="button" class="dap-loc__reveal" data-dap-loc-reveal>Ukázat lokalitu</button>' +
      '</span>' +
      '</span>' +
      '</dd>' +
      '</div>'
    );
  }

  function setLocOpen(arm, open) {
    arm.classList.toggle('is-open', open);
    arm.querySelectorAll('[data-dap-loc-toggle]').forEach((b) => b.setAttribute('aria-expanded', String(open)));
  }

  // Delegace na detailView - detail se při každém route() překresluje znovu.
  function initLocation() {
    detailView.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-dap-loc-toggle]');
      if (toggle) {
        const arm = toggle.closest('.dap-loc__arm');
        setLocOpen(arm, !arm.classList.contains('is-open'));
        return;
      }
      const reveal = e.target.closest('[data-dap-loc-reveal]');
      if (reveal) {
        const arm = reveal.closest('.dap-loc__arm');
        setLocOpen(arm, false);
        arm.classList.add('is-revealed');
        // rozmazané tlačítko zmizí - fokus by jinak spadl na začátek stránky
        arm.querySelector('.dap-loc__value').focus();
      }
    });

    // Klik vedle a Escape vysvětlivku zavřou. Klik na samotný přepínač se sem
    // dostane až po obsluze výše a otevřený prvek ho obsahuje, takže ho nezavře.
    document.addEventListener('click', (e) => {
      const open = detailView.querySelector('.dap-loc__arm.is-open');
      if (open && !open.contains(e.target)) setLocOpen(open, false);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      const open = detailView.querySelector('.dap-loc__arm.is-open');
      if (!open) return;
      setLocOpen(open, false);
      open.querySelector('[data-dap-loc-toggle]').focus();
    });
  }

  // Sloupec s galerií je na desktopu 1.4fr z 1000px mřížky (viz .dap-detail), níž přes celou šířku.
  const DETAIL_SIZES = '(min-width: 1000px) 565px, 100vw';

  // Detail se otevírá na jeden request do feedu (~0,6 s), po deep-linku i bez
  // načteného katalogu. Skeleton drží rozvržení .dap-detail, ať stránka po
  // dotažení dat neposkočí. Třídy jsou v <style> v dap-cars.liquid.
  function detailSkeletonHtml() {
    return (
      '<span class="dap-sk dap-sk-line dap-detail-sk__back"></span>' +
      '<div class="dap-detail" aria-hidden="true">' +
      '<div class="dap-detail__media">' +
      '<span class="dap-sk dap-sk-line dap-detail-sk__main"></span>' +
      '<div class="dap-detail-sk__thumbs">' +
      '<span class="dap-sk dap-sk-line dap-detail-sk__thumb"></span>'.repeat(5) +
      '</div>' +
      '</div>' +
      '<div class="dap-detail__side">' +
      '<span class="dap-sk dap-sk-badge"></span>' +
      '<span class="dap-sk dap-sk-line dap-detail-sk__title"></span>' +
      '<span class="dap-sk dap-sk-line dap-detail-sk__subtitle"></span>' +
      '<span class="dap-sk dap-sk-line dap-detail-sk__price"></span>' +
      '<span class="dap-sk dap-sk-line dap-detail-sk__cta"></span>' +
      '</div>' +
      '</div>' +
      '<p class="visually-hidden" role="status">Načítám vůz&hellip;</p>'
    );
  }

  function renderDetail(car) {
    const images = (car.images || []).map(safeUrl).filter(Boolean);
    const rows = SPECS.map((s) => [s[0], s[1](car)]).filter((r) => r[1] !== '' && r[1] != null);
    const specRows = rows.map(
      (r) => '<div class="dap-specs__row"><dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd></div>'
    );
    // řádek lokality z A/B/C testu patří před VIN
    const vinAt = rows.findIndex((r) => r[0] === 'VIN');
    specRows.splice(vinAt === -1 ? specRows.length : vinAt, 0, locRowHtml(car));
    const extras = addonList(car);
    detailAddons = extras;
    const mileageAddon = extras.findIndex((a) => MILEAGE_ADDON.test(a.label));
    const terms = termList(mileageAddon !== -1);

    detailView.innerHTML =
      '<a href="' + esc(urlWith(null)) + '" data-dap-back class="dap-back">&larr; Zpět na výpis</a>' +
      '<div class="dap-detail">' +
      '<div class="dap-detail__media">' +
      (images.length
        ? '<img class="dap-detail__main" ' +
          imgSized(images[0], 1200, [600, 900, 1200, 1600], DETAIL_SIZES) +
          ' alt="' + esc(carTitle(car)) + '">' +
          (images.length > 1
            ? '<div class="dap-detail__thumbs">' +
              images
                .map(
                  (src, i) =>
                    '<img loading="lazy" decoding="async" src="' + esc(imgUrl(src, 200)) + '"' +
                    ' data-dap-thumb="' + i + '" class="' + (i === 0 ? 'is-active' : '') + '" alt="">'
                )
                .join('') +
              '</div>'
            : '')
        : '') +
      '</div>' +
      '<div class="dap-detail__side">' +
      // štítky drží řádek sám o sobě - .dap-detail__side je flex column
      '<div class="tw-flex tw-items-center tw-gap-[4px] tw-flex-wrap">' +
      (CFG.badgeText
        ? '<span class="tw-px-[8px] tw-py-[6px] tw-rounded-[1.6rem] tw-lowercase tw-bg-green-500 tw-text-primaryDarker tw-font-semibold tw-leading-[100%] tw-tracking-[0.05em] tw-text-[1.2rem] tw-w-fit">' +
          esc(CFG.badgeText) +
          '</span>'
        : '') +
      (car.condition
        ? '<span class="tw-px-[8px] tw-py-[6px] tw-rounded-[1.6rem] tw-lowercase tw-bg-green-200 tw-text-primaryDarker tw-font-semibold tw-leading-[100%] tw-tracking-[0.05em] tw-text-[1.2rem] tw-w-fit">' +
          esc(car.condition) +
          '</span>'
        : '') +
      '<span class="dap-cebia">' + ICONS.cebia + '</span>' +
      '</div>' +
      '<h1 class="dap-detail__title">' + esc(carTitle(car)) + '</h1>' +
      (car.title && car.title !== carTitle(car)
        ? '<p class="dap-detail__subtitle">' + esc(car.title) + '</p>'
        : '') +
      '<div class="dap-detail__price">' +
      '<div class="cell-price tw-flex tw-items-center tw-gap-[4px]">' +
      '<span class="tw-leading-[20px] tw-text-[12px]">za</span>' +
      '<span class="tw-font-[700] tw-text-[2.4rem] tw-leading-[3rem]">' +
      (car.monthlyPaymentCzk ? czk(car.monthlyPaymentCzk) : 'cena na dotaz') +
      '</span>' +
      '</div>' +
      (car.monthlyPaymentCzk
        ? '<div class="tw-text-[12px] tw-text-green-700 tw-font-medium tw-leading-[1.2]">' + esc(vatLabel()) + '</div>'
        : '') +
      (terms.length
        ? '<ul class="dap-terms">' +
          terms.map((t) => '<li>' + t + '</li>').join('') +
          '</ul>'
        : '') +
      (car.depositCzk ? '<p class="dap-detail__note">Vratná kauce ' + czkRaw(car.depositCzk) + '</p>' : '') +
      '</div>' +
      '<button type="button" class="button button-primary dap-detail__cta" data-dap-enquire>' +
      esc(CFG.ctaText) +
      '</button>' +
      '</div>' +
      '</div>' +
      '<h2 class="dap-detail__heading">Parametry auta</h2>' +
      '<dl class="dap-specs">' +
      specRows.join('') +
      '</dl>' +
      buyBlockHtml(car) +
      '<h2 class="dap-detail__heading">Co je v ceně měsíční splátky</h2>' +
      '<ul class="dap-included">' +
      INCLUDED.map(
        (i) =>
          '<li class="dap-included__item dap-included__item--' + i[0] + '">' +
          ICONS[i[0]] +
          '<span>' + esc(i[1]) + '</span></li>'
      ).join('') +
      '</ul>' +
      (extras.length
        ? '<h2 class="dap-detail__heading">Můžete si přikoupit navíc</h2><ul class="dap-addons">' +
          extras
            .map(
              (a, i) =>
                '<li class="dap-addons__item"' + (i === mileageAddon ? ' id="' + MILEAGE_ADDON_ID + '"' : '') + '>' +
                '<label class="dap-addons__label">' +
                '<input type="checkbox" data-dap-addon="' + i + '">' +
                '<span>' + esc(a.label) + '</span>' +
                '</label>' +
                (a.price != null
                  ? '<span class="dap-addons__price">+ ' + czk(a.price) + ' / měs.</span>'
                  : '') +
                '</li>'
            )
            .join('') +
          '</ul>'
        : '');

    const cta = detailView.querySelector('[data-dap-enquire]');
    if (cta) cta.addEventListener('click', () => openModal(car));
    setupSticky(car, cta);

    const buyCta = detailView.querySelector('[data-dap-buy]');
    if (buyCta) buyCta.addEventListener('click', () => openModal(car, 'buy'));

    // Holá kotva by přes popstate spustila route() a detail překreslila nahoře - skrolujeme ručně.
    const scrollLink = detailView.querySelector('[data-dap-scroll]');
    if (scrollLink) {
      scrollLink.addEventListener('click', (e) => {
        const target = document.getElementById(MILEAGE_ADDON_ID);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    const main = detailView.querySelector('.dap-detail__main');
    const thumbs = detailView.querySelectorAll('[data-dap-thumb]');
    let activeIndex = 0;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        activeIndex = Number(thumb.dataset.dapThumb) || 0;
        // thumb.src je zmenšený náhled - do hlavní fotky patří velká varianta
        main.src = imgUrl(images[activeIndex], 1200);
        main.removeAttribute('srcset');
        thumbs.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });

    if (main) {
      main.addEventListener('click', () => openLightbox(images, activeIndex, carTitle(car)));
    }
  }

  /* ---------- poptávkový modal ---------- */

  // Validace kopíruje pravidla z lead-modal.liquid, ať se leady chovají stejně.
  const VALIDATORS = {
    firstName: (v) => (/^[\p{L}][\p{L}\s'-]{1,}$/u.test(v) ? '' : 'Zadejte křestní jméno.'),
    lastName: (v) => (/^[\p{L}][\p{L}\s'-]{1,}$/u.test(v) ? '' : 'Zadejte příjmení.'),
    // IČO je nepovinné - prázdné projde, vyplněné musí sedět na modulo 11 (stejně jako lead-modal.liquid)
    ico: (v) => {
      if (!v) return '';
      if (!/^\d{8}$/.test(v)) return 'IČO musí mít 8 číslic.';
      let sum = 0;
      for (let i = 0; i < 7; i++) sum += Number(v[i]) * (8 - i);
      return Number(v[7]) === (11 - (sum % 11)) % 10 ? '' : 'Zkontrolujte IČO, číslo nesedí.';
    },
    email: (v) => (/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v) ? '' : 'Zadejte platný e-mail.'),
    phone: (v) => {
      let s = v.replace(/\s/g, '');
      if (s.startsWith('+420')) s = s.slice(4);
      else if (s.startsWith('00420')) s = s.slice(5);
      else if (s.startsWith('+')) s = s.slice(1);
      return /^\d{9}$/.test(s) ? '' : 'Zadejte platné telefonní číslo.';
    }
  };

  // Webhook chce předvolbu zvlášť od čísla, formulář má jedno pole.
  function splitPhone(raw) {
    let s = String(raw || '').replace(/[\s()\-/]/g, '');
    if (s.startsWith('00')) s = '+' + s.slice(2);
    const match = s.match(/^(\+\d{1,3})(\d{9,})$/);
    if (match) return { prefix: match[1], number: match[2] };
    return { prefix: '+420', number: s.replace(/^\+/, '') };
  }

  function uuid() {
    try {
      if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    } catch (e) {}
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }

  const str = (value) => (value == null || value === '' ? '' : String(value));

  // 'buy' = formulář otevřelo tlačítko z bloku o koupi, jinak jde o poptávku pronájmu.
  let modalEl, modalForm, modalCar = null, modalIntent = 'rent', lastFocused = null;
  // Výchozí nadpis formuláře stojí v Liquidu, u koupě ho přepisujeme - tohle je návrat zpět.
  let modalTitleDefault = '';

  function setFieldError(input, message) {
    const wrapper = input.closest('.input-wrapper');
    if (!wrapper) return;
    wrapper.classList.toggle('error', !!message);
    let err = wrapper.querySelector('.field-error');
    if (message) {
      if (!err) {
        err = document.createElement('small');
        err.className = 'field-error';
        wrapper.appendChild(err);
      }
      err.textContent = message;
    } else if (err) {
      err.remove();
    }
  }

  function validateForm() {
    let firstBad = null;
    Object.keys(VALIDATORS).forEach((name) => {
      const input = modalForm.elements[name];
      const message = VALIDATORS[name](input.value.trim());
      setFieldError(input, message);
      if (message && !firstBad) firstBad = input;
    });
    if (firstBad) firstBad.focus();
    return !firstBad;
  }

  function showModalState(name) {
    modalEl.querySelectorAll('[data-dap-modal-state]').forEach((el) => {
      el.hidden = el.dataset.dapModalState !== name;
    });
  }

  // Samotné overflow:hidden na body iOS Safari ignoruje - musí se doplnit
  // position:fixed a po zavření vrátit scroll tam, kde uživatel byl.
  let scrollLockY = 0;

  function lockScroll() {
    scrollLockY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = -scrollLockY + 'px';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  }

  function unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    window.scrollTo(0, scrollLockY);
  }

  function openModal(car, intent) {
    modalCar = car;
    modalIntent = intent === 'buy' && buyPrice(car) ? 'buy' : 'rent';
    const label = modalEl.querySelector('[data-dap-modal-car]');
    if (label) label.textContent = carTitle(car) + ' · ' + (car.vin || '');

    // Formulář je pro pronájem i koupi stejný, liší se jen nadpisem a cenou nad poli,
    // ať zákazník po kliknutí na "Mám zájem o koupi" vidí, k čemu se upisuje.
    const title = modalEl.querySelector('[data-dap-modal-title]');
    if (title) {
      title.textContent =
        modalIntent === 'buy' && CFG.leadHeadingBuy ? CFG.leadHeadingBuy : modalTitleDefault;
    }

    const priceLine = modalEl.querySelector('[data-dap-modal-price]');
    if (priceLine) {
      priceLine.hidden = modalIntent !== 'buy';
      priceLine.textContent =
        modalIntent === 'buy' ? 'Cena vozu ' + czkRaw(buyPrice(car)) : '';
    }

    modalForm.reset();
    Object.keys(VALIDATORS).forEach((name) => setFieldError(modalForm.elements[name], ''));
    showModalState('form');
    lastFocused = document.activeElement;
    modalEl.hidden = false;
    lockScroll();
    modalForm.elements.firstName.focus();
  }

  function closeModal() {
    modalEl.hidden = true;
    unlockScroll();
    if (lastFocused) lastFocused.focus();
  }

  /* ---------- dataLayer ---------- */

  // Vlastní pushe, ať POC nezávisí na DataLayerObject z ie-global.liquid.
  // Tvar kopíruje purchase z produktové stránky (ie-global.liquid, metoda cart()).
  function pushDataLayer(obj) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(obj);
  }

  // Jedno mapování vozu na GA4 item - sdílí ho view_item i purchase, ať v reportu
  // sedí položky na obou koncích trychtýře.
  // Částka jde z feedu tak, jak přijde - DPH přepínač mění jen zobrazení, ne měření.
  // priceOverride nese koncovou cenu vozu u poptávky na koupi - jinak se do měření
  // dostane měsíční splátka a hodnota konverze je o řád mimo.
  function carItem(car, priceOverride) {
    return {
      item_id: str(car.vin),
      item_name: carTitle(car),
      affiliation: location.hostname,
      index: 0,
      item_brand: str(car.brand),
      item_category: str(car.fuel),
      item_category2: str(car.transmission),
      item_category3: str(car.bodyType),
      item_category4: str(car.model),
      item_category5: str(CFG.durationText),
      item_list_id: 'dap-leasing',
      item_list_name: 'DAP leasing',
      item_variant: str(car.color),
      price: priceOverride != null ? priceOverride : Number(car.monthlyPaymentCzk) || 0,
      quantity: 1
    };
  }

  // Detail vozu se vykresluje klientsky, takže view_item posílá route() - ne
  // DOMContentLoaded jako ie-global.liquid na /products/ (tam je podmíněný
  // template.name == "product", který na page šabloně nikdy neplatí).
  // Poslední VIN si držíme, ať opakované route() na stejné auto (back/forward)
  // nenafoukne počty zobrazení; návrat na výpis ho resetuje, protože další
  // otevření detailu je nové zobrazení.
  let lastViewedVin = null;

  function pushViewItem(car) {
    if (!car || car.vin === lastViewedVin) return;
    lastViewedVin = car.vin;

    // ecommerce: null čistí předchozí objekt, stejně jako to dělá sendGA4
    pushDataLayer({ ecommerce: null });
    pushDataLayer({
      event: 'view_item',
      ecommerce: {
        currency: CFG.currency || 'CZK',
        value: Number(car.monthlyPaymentCzk) || 0,
        items: [carItem(car)]
      }
    });
  }

  function pushLeadEvents(car, user, transactionId) {
    // Do měření jde vědomě jen samotné auto - zaškrtnuté příplatky se posílají pouze
    // do leadu (addons + note), jako položky 'opt-ins' v dataLayeru je neduplikujeme.
    // U koupě je hodnotou konverze koncová cena vozu, u pronájmu měsíční splátka.
    const price =
      modalIntent === 'buy' && buyPrice(car) ? buyPrice(car) : Number(car.monthlyPaymentCzk) || 0;

    pushDataLayer({
      event: 'userDataSetup',
      userData: { email: user.email, phone: user.phone }
    });

    // ecommerce: null čistí předchozí objekt, stejně jako to dělá sendGA4
    pushDataLayer({ ecommerce: null });
    pushDataLayer({
      event: 'purchase',
      ecommerce: {
        currency: CFG.currency || 'CZK',
        value: price,
        transaction_id: transactionId,
        coupon: '',
        items: [carItem(car, price)]
      }
    });

    // Marketingový souhlas DAP formulář nesbírá, proto všude 0 (shortterm je vždy opačný).
    pushDataLayer({
      event: 'cpd_consent',
      payload: {
        consent_a_dp: 0,
        consent_b_da: 0,
        consent_c_bi: 0,
        consent_d_fi: 0,
        consent_e_gdpr: 0,
        consent_f_shortterm: 1,
        consent_source: 'dap_lead'
      }
    });
  }

  // Stav zaškrtnutí drží DOM detailu, čteme ho až při odeslání formuláře.
  function selectedAddons() {
    if (!detailView) return [];
    return Array.prototype.slice
      .call(detailView.querySelectorAll('[data-dap-addon]:checked'))
      .map((cb) => detailAddons[Number(cb.dataset.dapAddon)])
      .filter(Boolean);
  }

  // Poznámka pro obsluhu - ceny z feedu jsou bez DPH, ať v Make nevzniká pochybnost.
  function addonNote(list) {
    if (!list.length) return '';
    return (
      'Zájem o příplatek: ' +
      list
        .map((a) => a.label + (a.price != null ? ' (+ ' + czkRaw(a.price) + '/měs. bez DPH)' : ''))
        .join('; ')
    );
  }

  // Poptávka z bloku o koupi jde stejným formulářem jako pronájem, obsluha to pozná
  // z poznámky. Cena vozu chodí z feedu už s DPH, proto czkRaw.
  function leadNote(car, addons) {
    const buy =
      modalIntent === 'buy'
        ? 'Zájem o KOUPI vozu' + (buyPrice(car) ? ' (' + czkRaw(buyPrice(car)) + ' vč. DPH)' : '')
        : '';
    return [buy, addonNote(addons)].filter(Boolean).join(' | ');
  }

  async function submitLead(e) {
    e.preventDefault();
    if (!validateForm()) return;

    const btn = modalForm.querySelector('[data-dap-submit]');
    btn.disabled = true;
    btn.textContent = 'Odesílám…';

    const car = modalCar;
    const chosenAddons = selectedAddons();
    const phone = splitPhone(modalForm.elements.phone.value);
    // id konverze pro dataLayer - GA4 podle něj deduplikuje purchase
    const leadId = uuid();

    // Struktura je shodná s lead-modalem na /products/, ať ji Make zpracuje stejnou cestou.
    // DAP auta nejsou Shopify produkty, takže ID variant zůstávají prázdná - vůz se
    // dohledá přes VIN, který je součástí pageUrl.
    const payload = {
      firstName: modalForm.elements.firstName.value.trim(),
      lastName: modalForm.elements.lastName.value.trim(),
      ico: modalForm.elements.ico.value.trim(),
      email: modalForm.elements.email.value.trim(),
      phone: phone.prefix + phone.number,
      consent: true,
      productTitle: str(car.title) || carTitle(car),
      variantId: '',
      tariffName: str(CFG.durationText),
      tariffVariantId: '',
      addons: chosenAddons.map((a) => ({ variantId: '', name: a.label, monthlyPriceCzk: a.price })),
      note: leadNote(car, chosenAddons),
      // Rozlišení webu, ze kterého lead přišel - stejný formulář na stejný hook
      // posílá i direct-auto.cz. Feed má pro to pole `source` a preferuje ho
      // před trafficSource z UTM. Fallback drží hodnotu i kdyby se nastavení
      // sekce v adminu vyprázdnilo (prázdný řetězec by default v CFG přebil).
      source: CFG.leadSource || 'birne.com',
      pageUrl: location.href,
      UTM: (typeof getUTMData === 'function' && getUTMData()) || ''
    };

    try {
      if (!CFG.leadWebhook) throw new Error('leadWebhook není nastavený');
      const res = await fetch(CFG.leadWebhook, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      // konverze se měří až po potvrzení webhookem, stejně jako v lead-modal.liquid
      pushLeadEvents(car, { email: payload.email, phone: phone.prefix + phone.number }, leadId);
      showModalState('thankyou');
      // Primární metrika A/B/C testu lokality (VWO kampaň #28, event API name dapLead) -
      // pronájem i koupě dohromady. Tvar volání je snippet z VWO. Po skončení testu smazat.
      try {
        window.VWO = window.VWO || [];
        VWO.event = VWO.event || function () { VWO.push(['event'].concat([].slice.call(arguments))); };
        VWO.event('dapLead');
      } catch (vwoErr) {
        console.error('[dap-cars] VWO event dapLead selhal', vwoErr);
      }
    } catch (err) {
      console.error('[dap-cars] odeslání leadu selhalo', err);
      showModalState('error');
    } finally {
      btn.disabled = false;
      btn.textContent = CFG.submitText;
    }
  }

  function initModal() {
    stickyEl = root.querySelector('[data-dap-sticky]');
    initLightbox();
    modalEl = root.querySelector('[data-dap-modal]');
    if (!modalEl) return;
    modalForm = modalEl.querySelector('[data-dap-lead-form]');

    const modalTitle = modalEl.querySelector('[data-dap-modal-title]');
    modalTitleDefault = modalTitle ? modalTitle.textContent.trim() : '';

    if (!CFG.leadWebhook) {
      console.warn('[dap-cars] leadWebhook není vyplněný - formulář neodešle lead.');
    }

    modalForm.addEventListener('submit', submitLead);

    // chybu u pole schováme, jakmile ho uživatel začne opravovat
    modalForm.addEventListener('input', (e) => {
      if (e.target.name in VALIDATORS) setFieldError(e.target, '');
    });

    modalEl.addEventListener('click', (e) => {
      if (e.target.closest('[data-dap-modal-close]')) closeModal();
      if (e.target.closest('[data-dap-modal-retry]')) showModalState('form');
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !modalEl.hidden) closeModal();
    });
  }

  /* ---------- lightbox galerie ---------- */

  let lightboxEl, lightboxImages = [], lightboxIndex = 0, lightboxAlt = '';

  function isLightboxOpen() {
    return lightboxEl && !lightboxEl.hidden;
  }

  function showLightboxImage(index) {
    if (!lightboxImages.length) return;
    // cyklení dokola, ať se dá listovat i za okraj
    lightboxIndex = (index + lightboxImages.length) % lightboxImages.length;

    const img = lightboxEl.querySelector('[data-dap-lightbox-img]');
    img.src = imgUrl(lightboxImages[lightboxIndex], 1600);
    img.alt = lightboxAlt;

    const counter = lightboxEl.querySelector('[data-dap-lightbox-counter]');
    if (counter) counter.textContent = lightboxIndex + 1 + ' / ' + lightboxImages.length;

    // u jediné fotky nemá smysl ukazovat šipky ani počítadlo
    const single = lightboxImages.length < 2;
    lightboxEl.querySelectorAll('[data-dap-lightbox-prev], [data-dap-lightbox-next]').forEach((el) => {
      el.hidden = single;
    });
    if (counter) counter.hidden = single;
  }

  function openLightbox(images, index, alt) {
    if (!lightboxEl || !images.length) return;
    lightboxImages = images;
    lightboxAlt = alt || '';
    showLightboxImage(index || 0);
    lightboxEl.hidden = false;
    lockScroll();
    const close = lightboxEl.querySelector('[data-dap-lightbox-close]');
    if (close) close.focus();
  }

  function closeLightbox() {
    if (!isLightboxOpen()) return;
    lightboxEl.hidden = true;
    unlockScroll();
  }

  function initLightbox() {
    lightboxEl = root.querySelector('[data-dap-lightbox]');
    if (!lightboxEl) return;

    lightboxEl.addEventListener('click', (e) => {
      if (e.target.closest('[data-dap-lightbox-prev]')) return showLightboxImage(lightboxIndex - 1);
      if (e.target.closest('[data-dap-lightbox-next]')) return showLightboxImage(lightboxIndex + 1);
      if (e.target.closest('[data-dap-lightbox-close]')) return closeLightbox();
      // klik na tmavé pozadí (ne na fotku) zavírá
      if (e.target === lightboxEl) closeLightbox();
    });

    // swipe na mobilu
    let touchX = null;
    lightboxEl.addEventListener('touchstart', (e) => {
      touchX = e.changedTouches[0].clientX;
    }, { passive: true });
    lightboxEl.addEventListener('touchend', (e) => {
      if (touchX === null) return;
      const delta = e.changedTouches[0].clientX - touchX;
      if (Math.abs(delta) > 40) showLightboxImage(lightboxIndex + (delta < 0 ? 1 : -1));
      touchX = null;
    }, { passive: true });

    document.addEventListener('keydown', (e) => {
      if (!isLightboxOpen()) return;
      if (e.key === 'Escape') closeLightbox();
      else if (e.key === 'ArrowLeft') showLightboxImage(lightboxIndex - 1);
      else if (e.key === 'ArrowRight') showLightboxImage(lightboxIndex + 1);
    });
  }

  /* ---------- mobilní sticky lišta ---------- */

  let stickyEl, stickyObserver = null;

  // Telefon nabízíme jen v době, kdy ho má kdo zvednout - jindy v liště zůstane
  // samotné CTA. Rozhoduje čas v Praze, ne lokální čas návštěvníka (dovolená,
  // cizí časové pásmo v mobilu). Bez Intl nebo s nesmyslným nastavením telefon
  // radši necháme, ať se o lead nepřijde.
  function phoneOpen() {
    const from = Number(CFG.phoneFromHour);
    const to = Number(CFG.phoneToHour);
    if (!isFinite(from) || !isFinite(to) || from > to) return true;
    if (from === to) return false;

    let day, hour, minute;
    try {
      new Intl.DateTimeFormat('en-US', {
        timeZone: 'Europe/Prague',
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      })
        .formatToParts(new Date())
        .forEach((part) => {
          if (part.type === 'weekday') day = part.value;
          else if (part.type === 'hour') hour = Number(part.value);
          else if (part.type === 'minute') minute = Number(part.value);
        });
    } catch (e) {
      return true;
    }
    if (!isFinite(hour) || !isFinite(minute)) return true;
    // některé enginy vrací o půlnoci "24" místo "00"
    if (hour === 24) hour = 0;
    if (['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].indexOf(day) === -1) return false;

    const now = hour + minute / 60;
    return now >= from && now < to;
  }

  // Vyhodnocuje se při každém zobrazení lišty, ne jen při vykreslení detailu -
  // na otevřené stránce tak přechod přes 17:00 telefon schová.
  function syncStickyPhone() {
    const phone = stickyEl && stickyEl.querySelector('[data-dap-sticky-phone]');
    if (phone) phone.hidden = !phoneOpen();
  }

  function hideSticky() {
    if (stickyObserver) {
      stickyObserver.disconnect();
      stickyObserver = null;
    }
    if (stickyEl) stickyEl.hidden = true;
  }

  // Lišta se ukáže, teprve když hlavní CTA zmizí z obrazovky - stejně jako
  // ie-mobile-sticky-controller na produktové stránce. Skrytí nad 640 px řeší CSS.
  function setupSticky(car, cta) {
    hideSticky();
    if (!stickyEl || !cta || !car.monthlyPaymentCzk) return;

    const price = stickyEl.querySelector('[data-dap-sticky-price]');
    const note = stickyEl.querySelector('[data-dap-sticky-note]');
    if (price) price.textContent = czk(car.monthlyPaymentCzk);
    if (note) note.textContent = cardNote();

    const btn = stickyEl.querySelector('[data-dap-enquire-sticky]');
    if (btn) btn.onclick = () => openModal(car);

    syncStickyPhone();

    if (typeof IntersectionObserver !== 'function') return;
    stickyObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) syncStickyPhone();
          stickyEl.hidden = entry.isIntersecting;
        });
      },
      { threshold: 0 }
    );
    stickyObserver.observe(cta);
  }

  /* ---------- routing ---------- */

  const baseTitle = document.title;

  function currentVin() {
    return new URLSearchParams(location.search).get(CFG.vinParam);
  }

  // Odkazy stavíme z aktuálních parametrů, ať v URL přežije ?lokalita i UTM z kampaní.
  function urlWith(vin) {
    const params = new URLSearchParams(location.search);
    if (vin) params.set(CFG.vinParam, vin);
    else params.delete(CFG.vinParam);
    const query = params.toString();
    return location.pathname + (query ? '?' + query : '');
  }

  async function route() {
    const vin = currentVin();

    if (!vin) {
      detailView.hidden = true;
      listView.hidden = false;
      lastViewedVin = null;
      hideSticky();
      closeLightbox();
      document.title = baseTitle;
      renderList();
      return;
    }

    listView.hidden = true;
    detailView.hidden = false;
    detailView.innerHTML = detailSkeletonHtml();

    try {
      const car = state.cars.find((c) => c.vin === vin) || (await fetchCar(vin));
      if (!car) throw new Error('vůz nenalezen');
      renderDetail(car);
      pushViewItem(car);
      document.title = carTitle(car) + ' | ' + baseTitle;
    } catch (err) {
      detailView.innerHTML =
        '<p class="dap-error">Vůz se nepodařilo načíst (' +
        esc(err.message) +
        '). <a href="' +
        esc(urlWith(null)) +
        '" data-dap-back>Zpět na výpis</a></p>';
    }

    window.scrollTo({ top: Math.max(root.offsetTop - 80, 0), behavior: 'smooth' });
  }

  function navigate(url) {
    history.pushState({}, '', url);
    route();
  }

  /* ---------- start ---------- */

  async function init(el) {
    root = el;
    listView = root.querySelector('[data-dap-list]');
    detailView = root.querySelector('[data-dap-detail]');
    facetsEl = root.querySelector('[data-dap-facets]');
    gridEl = root.querySelector('[data-dap-grid]');
    countEl = root.querySelector('[data-dap-count]');
    moreEl = root.querySelector('[data-dap-more]');
    sortEl = root.querySelector('[data-dap-sort]');
    toolbarEl = root.querySelector('[data-dap-toolbar]');
    const toolbarSkeleton = root.querySelector('[data-dap-toolbar-skeleton]');

    initModal();
    initLocation();

    sortEl.innerHTML = SORTS.map((s) => '<option value="' + s.value + '">' + s.label + '</option>').join('');
    sortEl.value = state.sort;

    sortEl.addEventListener('change', () => {
      state.sort = sortEl.value;
      state.shown = CFG.pageSize;
      renderGrid();
    });

    facetsEl.addEventListener('change', (e) => {
      const input = e.target.closest('input[type="checkbox"][data-facet]');
      if (!input) return;
      const sel = state.filters[input.dataset.facet];
      if (input.checked) sel.add(input.value);
      else sel.delete(input.value);
      pruneDependent();
      state.shown = CFG.pageSize;
      renderList();
    });

    facetsEl.addEventListener('click', (e) => {
      const reset = e.target.closest('[data-facet-reset]');
      if (!reset) return;
      e.preventDefault();
      state.filters[reset.dataset.facetReset].clear();
      pruneDependent();
      state.shown = CFG.pageSize;
      renderList();
    });

    moreEl.addEventListener('click', () => {
      state.shown += CFG.pageSize;
      renderGrid();
    });

    root.addEventListener('click', (e) => {
      const link = e.target.closest('[data-dap-link], [data-dap-back]');
      if (!link || e.metaKey || e.ctrlKey || e.shiftKey || link.target === '_blank') return;
      e.preventDefault();
      navigate(link.getAttribute('href'));
    });

    window.addEventListener('popstate', route);

    // Přepínač s DPH / bez DPH z ie-global.liquid. Samotné přepnutí obsluhuje
    // globální VATState (naváže se na .js-sme-switch na DOMContentLoaded),
    // my jen překreslíme ceny a dorovnáme vizuální stav přepínače.
    document.addEventListener("SMESwitched", route);

    // Deep-link na detail (?vin=...) celý katalog nepotřebuje - vystačí si s jedním
    // vozem z /cars/{vin} (~0,6 s). Pustíme ho hned a katalog dojede na pozadí
    // pro návrat na výpis. Bez awaitu, ať se detail vykreslí, jakmile dorazí.
    const deepLinkedVin = currentVin();
    if (deepLinkedVin) route();

    try {
      state.cars = await fetchAll();
    } catch (err) {
      // "Failed to fetch" / "NetworkError" = prohlížeč zahodil odpověď ještě před kódem,
      // což je typicky CORS (origin není v allowlistu API), ne chyba dat.
      // Podle jména a textu, ne přes instanceof - to selhává napříč realmy.
      // Chrome: "Failed to fetch", Firefox: "NetworkError...", Safari: "Load failed".
      const networkLevel =
        err.name === 'TypeError' || /failed to fetch|networkerror|load failed/i.test(err.message || '');
      console.error('[dap-cars] načtení katalogu selhalo', {
        endpoint: CFG.endpoint,
        origin: location.origin,
        error: err
      });
      if (toolbarSkeleton) toolbarSkeleton.remove();
      gridEl.innerHTML =
        '<p class="dap-error">Katalog se nepodařilo načíst.' +
        (networkLevel
          ? '<br>Požadavek zablokoval prohlížeč — nejspíš CORS. Origin <code>' +
            esc(location.origin) +
            '</code> pravděpodobně není v allowlistu API.'
          : '<br>' + esc(err.message)) +
        '</p>';
      return;
    }

    if (toolbarSkeleton) toolbarSkeleton.remove();
    toolbarEl.hidden = false;

    // Detail už běží z deep-linku - nepřekreslujeme ho podruhé, jen pod ním
    // potichu připravíme výpis, aby byl návrat zpět okamžitý.
    if (deepLinkedVin && currentVin() === deepLinkedVin) renderList();
    else route();
  }

  document.querySelectorAll('[data-dap-cars]').forEach(init);
})();
